import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 24, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 208 128"
    {...rest}
  >
    <rect
      width="198"
      height="118"
      x="5"
      y="5"
      ry="10"
      stroke={color}
      strokeWidth="10"
      fill="none"
    />
    <path
      d="M30 98V30h20l20 25 20-25h20v68H90V59L70 84 50 59v39zm125 0l-30-33h20V30h20v35h20z"
      fill={color}
    />
  </svg>
);
